import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../Hotels"
import { HotelOtaRatePlans } from "../../../../HotelOtaRatePlans"
import { useOutletContext } from "../../../../router-utils"

export default function HotelOtaRatePlansPage() {
	const { hotel } = useOutletContext<{ hotel: IHotel }>()
	return (
		<>
			<Helmet>
				<title>Rate Plans | Hotel</title>
			</Helmet>
			<HotelOtaRatePlans hotelId={hotel.id} />
		</>
	)
}
